import * as packet from './package';
import * as coupon from './coupon';

export default ({
  packet,
  coupon
});